import axios from 'axios';
import { API_REST_URL } from '../constants/env';
// Fetches an API response.
const callApi = (endpoint, method = 'GET', token, data) => {
    const config = {
        baseURL: API_REST_URL,
        method: method.toLowerCase(),
        url: endpoint,
        headers: {},
        data: void 0,
        // timeout: 3000,
    };
    if (token) {
        // @ts-expect-error
        config.headers['x-auth-token'] = token;
    }
    if (data) {
        config.data = data;
    }
    return axios(config).catch((error) => Promise.reject(error));
};
// Action key that carries API call interpreted by this Redux middleware.
export const CALL_API = 'Call API';
// A Redux middleware that interprets actions with CALL_API into specified.
// Performs the call and promises when such action are dispatched.
export default (store) => (next) => (action) => {
    const callAPI = action[CALL_API];
    if (typeof callAPI === 'undefined') {
        return next(action);
    }
    let { endpoint } = callAPI;
    const { types, method, token, data } = callAPI;
    if (typeof endpoint === 'function') {
        endpoint = endpoint(store.getState());
    }
    if (typeof endpoint !== 'string') {
        throw new Error('Specify a string endpoint URL.');
    }
    if (!Array.isArray(types) || types.length !== 3) {
        throw new Error('Expected an array of three action types');
    }
    if (!types.every((type) => typeof type === 'string')) {
        throw new Error('Expected action types to be strings.');
    }
    const actionWith = (inputData) => {
        const finalAction = { ...action, ...inputData };
        delete finalAction[CALL_API];
        return finalAction;
    };
    const [requestType, successType, failureType] = types;
    next(actionWith({ type: requestType }));
    return callApi(endpoint, method, token, data).then((response) => next(actionWith({
        response,
        type: successType,
    })), (error) => {
        let json;
        try {
            json = JSON.parse(error);
        }
        catch (exception) {
            json = error;
        }
        return next(actionWith({
            type: failureType,
            error: json && (json.error || json.detail || json),
        }));
    });
};
